import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=f6910908&scoped=true&"
import script from "./SalesList.vue?vue&type=script&lang=js&"
export * from "./SalesList.vue?vue&type=script&lang=js&"
import style0 from "./SalesList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SalesList.vue?vue&type=style&index=1&id=f6910908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6910908",
  null
  
)

export default component.exports